export default "__VITE_ASSET__DCe2jUFP__"